import MDEditor from '@uiw/react-md-editor';
import React from 'react';

type MarkdownViewerProps = {
  content: string;
  className?: string;
  colorMode?: 'light' | 'dark';
};

const MarkdownViewer: React.FC<MarkdownViewerProps> = ({
  content,
  className = '',
  colorMode = 'light',
}) => {
  // Utility function to add backslashes before 4-digit years followed by dots
  const transformParagraphContent = (content: string): string => {
    if (!content) return '';

    // Regex to match 4-digit year at the start followed by a dot
    // This will only match patterns like "1989." at the beginning of the content
    return content.replace(/^(\d{4})\./g, '$1\\.');
  };

  return (
    <div
      className={`modal-book-wrapper-content-paragraph content-box ${className}`}
      data-color-mode={colorMode}
    >
      <MDEditor.Markdown source={transformParagraphContent(content)} />
    </div>
  );
};

export default MarkdownViewer;
